import React, { useState, useEffect, useMemo } from 'react';
import appLogger from '@public/log/monitor';
import { HelperCore } from '@/common/helper';
import './index.scss';
import Loader from '@/common/helper/loader';
import globalStore from '@/store/global';

const openPage = ({ title = '', url }) => {
  HelperCore.openPage(url);
};

const ReferenceDrawerItem = props => {
  const { index = '', item } = props;
  
  return (
    <div
      onClick={evt => {
        openPage(item);
      }}
      className={[
        'reference-item w-full',
        index == 1 ? 'pt-8px pb-20px' : 'py-20px',
      ]}
    >
      <div className="flex items-center">
        <div className={`size-20px vh-center bg-opacity-10 rounded-full flex-shrink-0 text-13px font-bold text-black text-opacity-50 ${globalStore.isDark ? 'bg-[rgba(255,255,255,0.06)]' : 'bg-black'}`}>
          {index}
        </div>
        <div className={`title ml-5px truncate text-16px leading-23px ${globalStore.isDark ? 'text-white' : 'text-black'}`}>
          {HelperCore.getHtmlText(item.title)}
        </div>
      </div>
      <div className="flex mt-10px mb-12px">
        <div className={`line-clamp-2 text-14px leading-22px text-opacity-50 ${globalStore.isDark ? 'text-white' : 'text-black'}`}>
          {item.summary}
        </div>
        {item.cover ? (
          <img
            className="size-48px rounded-8px ml-8px"
            src={item.cover}
            alt=""
          />
        ) : null}
      </div>

      <div className={`flex items-center text-12px leading-17px text-opacity-50 ${globalStore.isDark ? 'text-white' : 'text-black'}`}>
        <img
          className="size-14px rounded-full mr-6px"
          src={item.icon || Loader.getFavIcon(item.url)}
          alt=""
        />
        <div className="mr-12px">{item.site}</div>
        <div className="">{item.date}</div>
      </div>
    </div>
  );
};

const ReferenceList = props => {
  const { className = '', list, scene } = props;
  const isDrawer = scene == 'drawer';

  const referenceList = useMemo(() => {
    if (!list) return [];
    return list;
  }, []);

  return (
    <div className={`w-full ref-container pt-8px ${className}`}>
      {referenceList?.length &&
        referenceList.map((item, index) => {
          return (
            <ReferenceDrawerItem key={index} index={index + 1} item={item} />
          );
        })}
    </div>
  );
};

export default ReferenceList;
